import { render } from "./FinalNarrativeDraft.vue?vue&type=template&id=1ce855d6&scoped=true"
import script from "./FinalNarrativeDraft.vue?vue&type=script&lang=js"
export * from "./FinalNarrativeDraft.vue?vue&type=script&lang=js"

import "./FinalNarrativeDraft.vue?vue&type=style&index=0&id=1ce855d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce855d6"]])

export default __exports__